import { useSearch } from "@tanstack/react-router";
import { Bell, CalendarDays, Clock} from "lucide-react";
import { User } from "lucide-react";
import { AppointmentBooking } from "~/features/appointments/pages/booking";
import { useAppointmentFormStore } from "~/features/appointments/store/use-appointment-store";

export function BookingPage() {
    const { date: dateParam, slot: slotParam } = useSearch({ from: "/(dashboard)/dashboard/$program/reschedule-booking/" });
    const { step } = useAppointmentFormStore();

    const successUrl = `${window.location.origin}/dashboard/weight-loss/appointments/confirmation`;
    const errorUrl = `${window.location.origin}/dashboard/weight-loss/appointments/error`;

    return (
        <div className="flex flex-col w-full px-32 md:flex-row gap-4">
            {step === 1 && (
                <div className="mb-8 w-full md:w-[30%]">
                    <div className="flex flex-col bg-white border divide-y-2 border-[#E6E6E6] shadow-sm rounded-xl gap-2">
                        <h2 className="font-semibold text-lg text-center p-2">Weight loss consultation</h2>
                        <div className="flex flex-col gap-2 p-4">
                            <div className="flex items-center text-[#202020CC] text-sm gap-2">
                                <User className="size-4" />
                                <span>Maurice Umoh</span>
                            </div>
                            <div className="flex items-center text-[#202020CC] text-sm gap-2">
                                <CalendarDays className="size-4" />
                                <span>Wednesday Mar 26, 2025</span>
                            </div>
                            <div className="flex items-center text-[#202020CC] text-sm gap-2">
                                <Bell className="size-4" />
                                <span>12:00 AM, West africa</span>
                            </div>
                            <div className="flex items-center text-[#202020CC] text-sm gap-2">
                                <Clock className="size-4" />
                                <span>60 minutes</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className={step === 1 ? "w-full md:w-[70%]" : "w-full"}>
                <AppointmentBooking 
                    selectedDate={dateParam} 
                    selectedSlot={slotParam} 
                    to="/dashboard/$program/reschedule-booking" 
                    successUrl={successUrl} 
                    errorUrl={errorUrl} 
                />
            </div>
        </div>
    )
}
